// extracted by mini-css-extract-plugin
export default {"wrapper":"Ifa-z","play":"Jfa-z"};